<template>
    <el-dialog :title="title" :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true"
        width="512px">
        <el-form ref="form" :model="form" :rules="rules" label-width="86px">
            <el-form-item label="领域名称:" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-row type="flex" justify="end">
                <el-button @click="trunOff">取消</el-button>
                <el-button type="primary" @click="onSubmit">确认</el-button>
            </el-row>
        </el-form>
    </el-dialog>
</template>

<script>
import { reviewArea } from "@/api/basic"

export default {
    data: () => ({
        rules: {
            name: [
                { required: true, message: "请输入领域名称", trigger: 'blur' }
            ]
        },
        form: {
            name: ''
        }
    }),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        // 模式
        type: {
            default: 'add',
            type: String
        },
        // 编辑的数据
        editData: null | Object
    },
    methods: {
        trunOff() {
            this.showModal = false
        },
        handleUpdateFormModelByModalType() {
            const handlers = {
                add: () => {
                    this.form = {
                        name: ''
                    }
                },
                edit: () => {
                    const { id, name } = this.editData
                    this.form = {
                        id, name
                    }
                }
            }

            handlers[this.type]()
        },
        onSubmit() {
            const { form } = this

            this.$refs["form"].validate(async valid => {
                if (valid) {
                    this.submitting = true
                    try {
                        await reviewArea.create(form)
                        this.$message({
                            message: this.type === "add" ? '新增成功!' : '编辑成功!',
                            type: 'success'
                        });
                        this.$emit("onUpdate")
                        this.trunOff()
                    } catch {
                        this.$message.error("出错了!")
                    } finally {
                        this.submitting = false
                    }
                }
            })
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
        title() {
            const { type } = this

            const title = {
                add: "新建数据",
                edit: "编辑数据"
            }

            return title[type]
        }
    },
    watch: {
        show(newVal) {
            if (newVal) {
                this.handleUpdateFormModelByModalType()
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>